export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/diffStrings.19fa73b5.worker.js");
}
